//======> Docementation <======//
registerBlockType('tornado/block', {
    title: __('بلوك سجل معانا', 'tornado'),
    description: __('بلوك سجل معانا', 'tornado'),
    icon:'feedback',
    category: 'tornado',
    keywords: [ 'tornado', 'section' ],
    supports: {
        align: ['full','wide']
    },
    attributes: {
        section_title : {
            type: 'string',
            
        },
        section_description : {
            type: 'string',
           
        },
        link : {
            type: 'string',
            selector: '.link',
            default: '',
        },
        link_title : {
            type: 'string',
            selector: '.link_title',
            default: 'سجل معانا',
        }
    },
    //==== Editing Mode ====//
    edit: props => {
        //==== Block Data ====//
        const { attributes, setAttributes } = props;
        props.setAttributes( { align: 'full' } );
        //==== Main ====//
        const set_section_title = section_title => { setAttributes({section_title}) };
        const set_section_description = section_description => { setAttributes({section_description}) };
        const set_link = link => { setAttributes({link}) };
        const set_link_title = link_title => { setAttributes({link_title}) };
        
        //==== Block Structure ====//
        return (
            <Panel>
                 <PanelBody >
                    <InspectorControls key="inspector">
                        <PanelBody title={ __('Block Options', 'tornado') }>
                            {/* //=== Content Type ===// */}
                        
                            <TextControl className="link_title" label="عنوان اللينك" value={ attributes.link_title } onChange={ set_link_title } />
                            <TextControl className="link"  label="لينك" value={ attributes.link } onChange={ set_link } />
                            <TextControl  label="عنوان القطعه" value={ attributes.section_title } onChange={ set_section_title } />
                            <TextControl  label="وصف القطعه" value={ attributes.section_description } onChange={ set_section_description } />
                        </PanelBody>
                    </InspectorControls> 
                    <div className="banner-sec v2">
                        <div className="container">
                            {/*<!-- Grid -->*/}
                            <div className="row align-center-y align-center-x">
                                {/*<!-- Content -->*/}
                                <div className="col-12 col-m-9">
                                    <h5>{attributes.section_title}</h5>
                                    <p >{attributes.section_description}</p>
                                </div>
                                {/*<!-- Content -->*/}
                                <div className="col-12 col-m-3 link">
                                    <a href={attributes.link} className="btn primary large round-corner block-lvl link_title">{attributes.link_title}</a>
                                </div>
                            </div>
                            {/*<!-- // Grid -->*/}
                        </div>
                    </div>
                </PanelBody>
            </Panel>
        );
    },
    //==== Puplish Mode ====//
    save: props => {
        //==== Block Data ====//
        const { attributes } = props;

        //==== Block Structure ====//
        return (
            <div className="banner-sec v2">
                <div className="container">
                    {/*<!-- Grid -->*/}
                    <div className="row align-center-y align-center-x">
                        {/*<!-- Content -->*/}
                        <div className="col-12 col-m-9">
                            <h5>{attributes.section_title}</h5>
                            <p >{attributes.section_description}</p>
                        </div>
                        {/*<!-- Content -->*/}
                        <div className="col-12 col-m-3 link">
                            <a href={attributes.link} className="btn primary large round-corner block-lvl link_title">{attributes.link_title}</a>
                        </div>
                    </div>
                    {/*<!-- // Grid -->*/}
                </div>
            </div>
        );
    },
});